import { Component } from '@angular/core';
import { default as packageJson } from '../../../../../package.json';
import { TranslatePipe } from '@ngx-translate/core';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [TranslatePipe]
})
export class FooterComponent {
  public version = packageJson.version;
  constructor() {}
}
